import React from "react";
import { Link } from "react-router-dom";

const OrderCard = ({ title, image, date, status, amount, id }) => {
  return (
    <Link to={`/profile/order/${id}`}>
      <div className="bg-white rounded-lg shadow-md my-2 cursor-pointer">
        <div className="p-4 border-b border-gray-300">
          <div className="flex items-center">
            <img
              src={`${image}`}
              alt="Product"
              className="w-12 h-12 rounded-md mr-4"
            />
            <div>
              <p className="text-lg font-semibold line-clamp-1">{title}</p>
              <p className="text-gray-500 text-sm ">
                Order Date: {new Date(date).toLocaleString()}
              </p>
              <p className="text-gray-500 text-sm">Amount: {amount}</p>
              <p
                className={`${status === "Pending" && "text-gray-500"} text-sm`}
              >
                Status:{" "}
                <span
                  className={`${status === "Pending" && "text-blue-400 "} ${
                    status === "Recieved" && "text-blue-600"
                  } ${status === "Delivered" && "text-green-500 "} ${
                    status === "Pending" && "text-orange-500 "
                  } `}
                >
                  {status}
                </span>
              </p>
            </div>
          </div>
        </div>
        {/* Add more order items here */}
      </div>
    </Link>
  );
};

export default OrderCard;
